import AppContainer from './component'

export default AppContainer
